module.exports = __webpack_public_path__ + "img/stamp.04b2126c.png";